import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtMXN } from "@/lib/format";

const STATUSES = ["new", "contacted", "quoted", "confirmed", "completed", "cancelled"];
const STATUS_LABEL = {
  new: "Nuevo", contacted: "Contactado", quoted: "Cotizado",
  confirmed: "Confirmado", completed: "Completado", cancelled: "Cancelado",
};

export default function AdminParrilladas() {
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");

  const load = () => {
    api.get("/admin/parrilladas/quotes").then((r) => {
      setQuotes(r.data);
      setLoading(false);
    });
  };
  useEffect(load, []);

  const updateStatus = async (id, status) => {
    await api.patch(`/admin/parrilladas/quotes/${id}`, { status });
    load();
  };

  const filtered = filter === "all" ? quotes : quotes.filter((q) => q.status === filter);

  return (
    <div className="p-8" data-testid="admin-parrilladas">
      <h1 className="font-display text-4xl tracking-wider uppercase text-white mb-2">Parrilladas</h1>
      <p className="text-white/60 text-sm mb-8">Cotizaciones para servicios de parrilladas a domicilio.</p>

      <div className="flex gap-2 mb-6 flex-wrap">
        <FilterPill active={filter === "all"} onClick={() => setFilter("all")}>Todas ({quotes.length})</FilterPill>
        {STATUSES.map((s) => (
          <FilterPill key={s} active={filter === s} onClick={() => setFilter(s)}>
            {STATUS_LABEL[s]} ({quotes.filter((q) => q.status === s).length})
          </FilterPill>
        ))}
      </div>

      {loading ? (
        <div className="text-white/50">Cargando...</div>
      ) : filtered.length === 0 ? (
        <div className="text-white/40 p-10 text-center bg-arre-surface border border-arre-border">Sin cotizaciones en este estado.</div>
      ) : (
        <div className="space-y-4">
          {filtered.map((q) => (
            <div key={q.id} className="bg-arre-surface border border-arre-border p-6" data-testid={`quote-${q.id}`}>
              <div className="flex items-start justify-between flex-wrap gap-4 mb-4">
                <div>
                  <div className="font-display text-2xl text-white">{q.contact_name}</div>
                  <div className="text-xs text-white/50">
                    {q.contact_email} · {q.contact_phone}
                  </div>
                  <div className="text-xs text-white/40 mt-1">
                    {new Date(q.created_at).toLocaleString("es-MX")}
                  </div>
                </div>
                <select
                  value={q.status}
                  onChange={(e) => updateStatus(q.id, e.target.value)}
                  className="bg-arre-black border border-arre-border px-3 py-2 text-white text-xs tracking-widest uppercase"
                  data-testid={`status-${q.id}`}
                >
                  {STATUSES.map((s) => <option key={s} value={s}>{STATUS_LABEL[s]}</option>)}
                </select>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm border-t border-arre-border pt-4">
                <div>
                  <div className="text-[10px] tracking-widest uppercase text-white/50">Paquete</div>
                  <div className="text-white">{q.package_name}</div>
                  <div className="text-xs text-white/50">{q.complementos_count} complementos</div>
                </div>
                <div>
                  <div className="text-[10px] tracking-widest uppercase text-white/50">Personas</div>
                  <div className="font-display text-xl text-white">{q.persona_count}</div>
                </div>
                <div>
                  <div className="text-[10px] tracking-widest uppercase text-white/50">Estimado</div>
                  <div className="font-display text-xl text-arre-red">{fmtMXN(q.estimated_total)}</div>
                  <div className="text-xs text-white/50">{fmtMXN(q.price_per_person)}/persona</div>
                </div>
                <div>
                  <div className="text-[10px] tracking-widest uppercase text-white/50">Zona</div>
                  <div className="text-white">{q.location_state}</div>
                  {q.needs_viaticos && <div className="text-xs text-arre-red font-bold">+ Viáticos</div>}
                </div>
              </div>

              {(q.event_date || q.location_address || q.message || q.extras?.length > 0) && (
                <div className="mt-4 pt-4 border-t border-arre-border text-xs text-white/70 space-y-2">
                  {q.event_date && <div><span className="text-white/40">Fecha: </span>{q.event_date} {q.event_time}</div>}
                  {q.location_address && <div><span className="text-white/40">Dirección: </span>{q.location_address}</div>}
                  {q.extras?.length > 0 && <div><span className="text-white/40">Extras: </span>{q.extras.join(", ")}</div>}
                  {q.message && <div className="italic text-white/60">"{q.message}"</div>}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function FilterPill({ active, onClick, children }) {
  return (
    <button
      onClick={onClick}
      className={`px-4 py-2 text-xs tracking-widest uppercase border ${
        active ? "bg-arre-red border-arre-red text-white" : "bg-arre-surface border-arre-border text-white/70 hover:border-white/40"
      }`}
    >
      {children}
    </button>
  );
}
